module.exports = __webpack_public_path__ + "img/area_menu_more_normal.539de60d.svg";